const dateToString = (date: string) => {
  let newTime: string = '';
  if (!date) return '';
  newTime = new Date(date).toLocaleString()?.split(',')[0] + ' ' + new Date(date).toTimeString().substring(0, 5);
  return newTime;
};

export default dateToString;
